import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * When set to `true`, the auth interceptor sends the request ANONYMOUSLY —
 * no `Authorization` header — even if a staff, parent, or student token is
 * present in storage.
 *
 * The public registration flow (`/register/*`) is unauthenticated, but tokens
 * live in `localStorage`, which is shared across all tabs of the same origin.
 * Without this flag, a parent or student who left a portal open in another tab
 * would have THEIR token attached to the anonymous registration requests —
 * causing 401s when the token is expired or belongs to the wrong token stack,
 * and leaking a session token into a public context. Marking those requests
 * with `SKIP_AUTH` guarantees they go out anonymously regardless of stored
 * tokens.
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

/** Convenience: request options forcing an anonymous (token-free) request. */
export function anonymousContext(): { context: HttpContext } {
  return { context: new HttpContext().set(SKIP_AUTH, true) };
}
